import React from 'react';
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Button,
    Typography,
    Box
} from '@mui/material';
import { ICliente } from '../interfaces';
import Divider from '@mui/material/Divider';

interface TenantDetailsProps {
    open: boolean;
    onClose: () => void;
    cliente: ICliente | null;
}

const TenantDetails: React.FC<TenantDetailsProps> = ({ open, onClose, cliente }) => {
    if (!cliente) {
        return null;
    }

    return (
        <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth>
            <DialogTitle>Detalhes do Cliente</DialogTitle>
            <DialogContent>
                <Box sx={{ mb: 2 }}>
                    <Typography variant="h6">Informações Gerais</Typography>
                    <Typography><strong>Razão Social:</strong> {cliente.razaoSocial || 'N/A'}</Typography>
                    <Typography><strong>Nome Fantasia:</strong> {cliente.nomeFantasia || 'N/A'}</Typography>
                    <Typography><strong>CNPJ:</strong> {cliente.CNPJ || 'N/A'}</Typography>
                    <Typography><strong>E-mail:</strong> {cliente.email || 'N/A'}</Typography>
                    <Typography><strong>Telefone:</strong> {cliente.telefone || 'N/A'}</Typography>
                    <Typography><strong>Status:</strong> {cliente.ativo ? 'Ativo' : 'Inativo'}</Typography>
                </Box>
                <Divider sx={{ mb: 2 }} />
                {cliente.endereco && (
                    <Box sx={{ mb: 2 }}>
                        <Typography variant="h6">Endereço</Typography>
                        <Typography><strong>CEP:</strong> {cliente.endereco.CEP || 'N/A'}</Typography>
                        <Typography><strong>Logradouro:</strong> {cliente.endereco.logradouro || 'N/A'}</Typography>
                        <Typography><strong>Número:</strong> {cliente.endereco.numero || 'N/A'}</Typography>
                        <Typography><strong>Complemento:</strong> {cliente.endereco.complemento || 'N/A'}</Typography>
                        <Typography><strong>Bairro:</strong> {cliente.endereco.bairro || 'N/A'}</Typography>
                        <Typography><strong>Município:</strong> {cliente.endereco.municipio || 'N/A'}</Typography>
                        <Typography><strong>UF:</strong> {cliente.endereco.UF || 'N/A'}</Typography>
                    </Box>
                )}
                <Divider sx={{ mb: 2 }} />
                {cliente.contato && (
                    <Box sx={{ mb: 2 }}>
                        <Typography variant="h6">Contato</Typography>
                        <Typography><strong>Nome:</strong> {cliente.contato.nome || 'N/A'}</Typography>
                        <Typography><strong>CPF:</strong> {cliente.contato.cpf || 'N/A'}</Typography>
                        <Typography><strong>Estado Civil:</strong> {cliente.contato.estadoCivil || 'N/A'}</Typography>
                        <Typography><strong>DDD:</strong> {cliente.contato.telefone?.ddd || 'N/A'}</Typography>
                        <Typography><strong>Número:</strong> {cliente.contato.telefone?.numero || 'N/A'}</Typography>
                        <Typography><strong>WhatsApp:</strong> {cliente.contato.telefone?.whatsapp ? 'Sim' : 'Não'}</Typography>
                        <Typography><strong>Cargo/Função:</strong> {cliente.contato.cargoFuncao || 'N/A'}</Typography>
                        <Typography><strong>Responsável Técnico:</strong> {cliente.contato.responsavelTecnico ? 'Sim' : 'Não'}</Typography>
                        <Typography><strong>Responsável Financeiro:</strong> {cliente.contato.responsavelFinanceiro ? 'Sim' : 'Não'}</Typography>
                    </Box>
                )}
            </DialogContent>
            <DialogActions>
                <Button onClick={onClose} variant="contained" color="primary">
                    Fechar
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default TenantDetails;